var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"},on:{"keypres":_vm.onkeydown,"keyup":_vm.onkeydown,"keydown":_vm.onkeydown}},[_c('number-input',{model:{value:(_vm.p_value),callback:function ($$v) {_vm.p_value=$$v},expression:"p_value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }